import { CalendarOutlined } from '@ant-design/icons';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import { createValidDate, isValidDate, maxSqlDate, minSqlDate } from '../../Helpers/Calculations';
import './DateInputStyle.css';

const DateInput = props => {
    const { dataKey, data, onChange, state, warning, minDateFunc, maxDateFunc } = props;
    const err = warning !== undefined && warning !== '' ? "error" : "";

    const [minimumDate] = useState(typeof minDateFunc === 'function' ? minDateFunc() : minSqlDate);
    const [maximumDate] = useState(typeof maxDateFunc === 'function' ? maxDateFunc() : maxSqlDate);

    const myDate = data === ''
        ? ''
        : isValidDate(data)
            ? new Date(data)
            : new Date(createValidDate(data));

    const onChangeDate = (date) => {
        if (date === null || !isValidDate(date)) {
            onChange(dataKey, '', warning)
        }
        else {
            let val = date
            if (val < minimumDate) val = minimumDate;
            if (val > maximumDate) val = maximumDate;
            onChange(dataKey, val);
        }
    }

    return <span className='de_datepicker'>
        <DatePicker
            showIcon
            icon={<CalendarOutlined />}
            className={err
                ? 'ant-input datePickerCommon datePickerError'
                : 'ant-input datePickerCommon datePickerNoError'}
            isClearable
            dateFormat='MM/dd/yyyy'
            showPopperArrow={false}
            selected={myDate && new Date(myDate)}
            onChange={(date, _) => onChangeDate(date)}
            disabled={state.readonly}
            minDate={minimumDate}
            maxDate={maximumDate}
            placeholderText='MM/DD/YYYY'
            data-input={'dateinput_de'}
            onBlur={(e) => onChangeDate(new Date(e?.target?.value))}
        />
    </span>
}

export default DateInput;
